import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Outlet } from 'react-router';
import Header from 'components/header/header';
import InternetStatus from 'components/internet-status/internet-status';
const FinishLayout = () => {
    return (_jsxs("div", Object.assign({ className: "container--exam-student" }, { children: [_jsx(InternetStatus, {}, void 0), _jsx(Header, {}, void 0), _jsx("div", Object.assign({ className: "container--content container--fixed", style: { boxShadow: '0px 0px 0 0 rgb(0 0 0 / 10%)' } }, { children: _jsx(Outlet, {}, void 0) }), void 0)] }), void 0));
};
export default FinishLayout;
